resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function PhoneSelectCombo() {
    this.id = null;
    this.node = null;
    this.declaredClass = null;

    this._textField = null;
    this._selector = null;

    this.init = function() {
        this._textField = $("[data-mogo-ui='TextField']", this.node)[0];
        $(this.node).addClass("mogo-ui-phone-select-combo");
    };

    this.initAllReady = function() {
        this._selector = $("[data-mogo-ui='Select']", this.node)[0];

        // Connections
        $(this._selector).on("change", $.proxy(this._onChangeSelection, this));

        // Add icons
        var listItems = $("li", $(this._selector).mogo().containerDiv);
        for (var i = 0; i < listItems.length; i++) {
            var listItem = listItems[i];
            var text = $("<span>" + $(listItem).html() + "</span>").addClass("description");
            var iconContainer = $("<span></span>").addClass("icon-" + $(listItem).html().toLowerCase());
            $(listItem).html("");
            $(text).prependTo(listItem);
            $(iconContainer).prependTo(listItem);
        }

        this._onChangeSelection(null, true);
        $(this._selector).mogo().setSelectedIndex($(this._selector).mogo().selectedIndex);
        if ($(this._selector).mogo().val() == null) {
            $(".textLabel .description", $(this._selector).mogo().containerDiv).css("text-align", "left");
            $(".textLabel .icon-type", $(this._selector).mogo().containerDiv).css("display", "none");
            $(".textLabel .description", $(this._selector).mogo().containerDiv).css("display", "inline");
        }

        $(this.node).css("display", "block");
    };

    this._onChangeSelection = function(evt, init) {
        if ($(this.node).hasClass("initial") && $(this._selector).val() != null)
            $(this.node).removeClass("initial");
        if (init == null || !init)
            setTimeout($.proxy(function(){$(this._textField).focus();}, this), 200);
    };
}